module.exports = __webpack_public_path__ + "static/happy-couple-hiking-near-a-lake-mobile.3807ec8e.webp";